export enum AttachmentStatus {
  UPLOADING = 'UPLOADING',
  UPLOADED = 'UPLOADED',
  FAILED = 'FAILED',
  SAVED = 'SAVED',
  PENDING_UPLOAD = 'PENDING_UPLOAD',
  PENDING_DELETE = 'Pending Delete',
  NOT_UPLOADED = 'NOT_UPLOADED',
}
